import React, {Component} from 'react';
import PropTypes from 'prop-types';
import I18nText from '../../i18n/I18nText';

class HeadingWidget extends Component {
    render() {
        return (
            <h1>
                <I18nText content={this.props.widget.content} data-testid={this.props.widget.id} />
            </h1>
        );
    }
}

HeadingWidget.propTypes = {
    widget: PropTypes.object
};

export function type() {
    return 'heading';
}

export function initialValue(widget) {
    return undefined;
}

export function schema(widget, allowPartialSubmissions) {
    return undefined;
}

export function component() {
    return HeadingWidget;
}
